import {AfterViewInit, Component, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {BsDropdownDirective} from 'ngx-bootstrap/dropdown';
import {Subscription} from 'rxjs';
import {ContractModeEnum} from '../../../activity-report/models/contract-mode.enum';
import {AuthService} from '../../services/auth-service.service';
import {KpisService} from '../../services/kpis.service';
import {RoleService} from '../../services/role.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  feeCount: number = 0;
  OnCallCount: number = 0;
  ActivitySheetCount: number = 0;
  billOnlyCount: number = 0;
  fixedPriceCount: number = 0;

  updateSubscription: Subscription = null;

  @ViewChildren(BsDropdownDirective) dropdownList: QueryList<BsDropdownDirective>;

  constructor(protected authService: AuthService, private roleService: RoleService, private kpiService: KpisService) {}

  ngOnInit() {
    if (this.isRole('PROJECT_MANAGER')) {
      this.updateSubscription = this.kpiService.getUpdatedSubscription().subscribe(() => {
        this.loadKpis();
      });
      this.loadKpis();
    }
  }

  private loadKpis(): void {
    this.kpiService.getSubmittedFeeCount().subscribe(value => {
      this.feeCount = value;
    });
    this.kpiService.getSubmittedOnCallCount().subscribe(value => {
      this.OnCallCount = value;
    });
    this.kpiService.getSubmittedActivitySheetCount().subscribe(value => {
      this.ActivitySheetCount = value;
    });
    this.kpiService.getDuePaymentsPending(ContractModeEnum.BILL_ONLY).subscribe(value => {
      this.billOnlyCount = value;
    });
    this.kpiService.getDuePaymentsPending(ContractModeEnum.FIXED_PRICE).subscribe(value => {
      this.fixedPriceCount = value;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.dropdownList.forEach(dropdown => {
        dropdown.show();
        setTimeout(() => {
          dropdown.hide();
        });
      });
    });
  }

  isCompleted() {
    return !(this.authService.getCompanyStatus() === 'IN_PROGRESS' || this.authService.getCompanyStatus() === 'SUBMITTED');
  }

  isRole(role: string | string[]): boolean {
    return this.roleService.isRole(role);
  }

  ngOnDestroy(): void {
    if (this.updateSubscription !== null) {
      this.updateSubscription.unsubscribe();
    }
  }
}
